import { PrimaryButton } from "../Button/Buttons";
import { Plus } from "lucide-react";

/**
 * DashPageHeader — standardised title + description + optional action header
 * for full-page dashboard views (Spectra, Sparks, etc.)
 *
 * Props:
 *   title       — string  (h3, bold, 2xl)
 *   description — string  (muted paragraph below title)
 *   action      — optional { label, onClick } — renders a PrimaryButton top-right
 */
const DashPageHeader = ({ title, description, action }) => (
  <div className="flex items-start justify-between gap-4 mt-5 mb-5">
    <div className="flex-1 min-w-0">
      <h3 className="font-semibold text-2xl text-ink-ink dark:text-ink-white">{title}</h3>
      {description && (
        <p className="text-ink-gray-500 dark:text-ink-gray-400 text-sm mt-2">{description}</p>
      )}
    </div>
    {action && (
      <div className="flex-shrink-0 mt-1">
        <PrimaryButton onClick={action.onClick} className="flex items-center gap-1.5">
          <Plus className="w-4 h-4" />
          {action.label}
        </PrimaryButton>
      </div>
    )}
  </div>
);

export default DashPageHeader;
